/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Form_Isnotificationenabled_False2Inputs */



/**
* | output |
* | --- |
* | "Each state change will be recorded but will not trigger a notification" |
*
* @param {Alarms_Form_Isnotificationenabled_False2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_form_isnotificationenabled_false2 = /** @type {((inputs?: Alarms_Form_Isnotificationenabled_False2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Form_Isnotificationenabled_False2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Each state change will be recorded but will not trigger a notification")
	return /** @type {LocalizedString} */ ("Chaque changement d'état sera enregistré mais ne déclenchera pas de notification")
});
export { alarms_form_isnotificationenabled_false2 as "alarms_form_isNotificationEnabled_false" }